import { useMemo } from 'react';
import toast from 'react-hot-toast';

export type ToastKind = 'success' | 'error' | 'info' | 'warning';

type ToastDetail = {
  kind: ToastKind;
  message: string;
  durationMs?: number;
};

export const showToast = (detail: ToastDetail): void => {
  const options = detail.durationMs ? { duration: detail.durationMs } : undefined;
  switch (detail.kind) {
    case 'success':
      toast.success(detail.message, options);
      break;
    case 'error':
      toast.error(detail.message, options);
      break;
    default:
      toast(detail.message, options);
      break;
  }
};

export const useToast = () =>
  useMemo(
    () => ({
      success: (message: string) => toast.success(message),
      error: (message: string) => toast.error(message),
      info: (message: string) => toast(message),
      warning: (message: string) => toast(message),
      dismiss: (id?: string) => toast.dismiss(id),
    }),
    [],
  );

export type { ToastDetail };
